import { API } from '../../utils/amplifyWrapper';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import clean from '../../utils/Clean';

interface IEditProfileRequestProps {
    org_id: string
    id: string 
    profile_id: string
    profile: Object
}

export const useEditProfile = () => {
    const queryClient = useQueryClient();
    
    return useMutation(
        async ({ org_id, id, profile_id, profile }: IEditProfileRequestProps) => {
            const response = await API.put(
                `main`, 
                `/organisation/${org_id}/integration/${id}/audio_profile/${profile_id}`,
                {body: clean(profile), headers: {"Content-Type":"application/json"}}
            );
            return { response, org_id, id };
        },
        {
            onSuccess: ({ org_id, id }) => {
                // ✨ Invalidate queries at hook level
                queryClient.invalidateQueries(['audio_profile', org_id, id]);
            }
        }
    )
}


